import PricePlanBase from 'modules/digital-product/price-plans/components/price-plan-base'
import PricePlanTooltip from 'modules/digital-product/price-plans/components/price-plan-tooltip'
import { PricePlanType } from '@systemeio/types'
import React, { FC } from 'react'

interface Props {
  pricePlans: PricePlanType[]
}

export const PricePlansReadOnly: FC<Props> = ({ pricePlans }) => {
  return (
    <PricePlanBase>
      {pricePlans.map(pricePlan => (
        <div
          key={pricePlan.id}
          className="border-text-secondary/30 flex w-full items-center justify-between rounded-lg border p-2"
        >
          <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3">
            <PricePlanTooltip
              pricePlan={pricePlan}
              label={
                <div className="text-brand-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]">
                  <span>{pricePlan.innerName || 'test.price.plan.name'}</span>
                </div>
              }
            />
          </div>
        </div>
      ))}
    </PricePlanBase>
  )
}
